export default "__VITE_ASSET__DX5AKkvl__"